import { render } from "./AccountRegistrationInstitutionDetail.vue?vue&type=template&id=d23d35ce"
import script from "./AccountRegistrationInstitutionDetail.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationInstitutionDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__